import axios from "axios";
import { API_USER_DOMAIN } from "../constants";
import { handleError } from "../errorHandler";

export const getUserInfo = (onSuccess: Function, onFailure: Function) => {
  axios
    .get(API_USER_DOMAIN)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};
